<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="800px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="100px" class="content">
      <el-row v-for="(item, index) in addForm.updateList" :key="index">
        <el-col :span="10">
          <el-form-item label="摄影师" :prop="'updateList.' + index + '.userIdMain'" :rules="rules.userIdMain">
            <el-select
              v-model="item.userIdMain"
              filterable
              remote
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loading"
              @change="handleUserInfoChange(index, true)"
              @focus="oneIndex = index"
            >
              <el-option v-for="item in item.userList" :key="item.userId" :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`" :value="item.userId"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="摄影师助理">
            <el-select
              style="margin-right: 5px"
              v-model="item.userIdDeputy"
              filterable
              remote
              placeholder="请输入关键词"
              :remote-method="remoteMethod1"
              :loading="loading"
              @change="handleUserInfoChange(index, false)"
              @focus="twoIndex = index"
              clearable
            >
              <el-option v-for="item in item.userList1" :key="item.userId" :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`" :value="item.userId"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="line-height: 32px">
          <el-button size="mini" @click="addRow(index)" icon="el-icon-plus" class="green">添加</el-button>
          <el-button  size="mini" @click="delRow(index)" icon="el-icon-close" v-if="index > 0 || addForm.updateList.length > 1" class="red">删除</el-button>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
        updateList: [{ userIdMain: "", userIdDeputy: "" }],
      },
      userId: "",
      userList: [],
      all: false,
      rules: {
        userIdMain: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loading: false,
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
        oneIndex: 0,
        towIndex: 0,
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "新增";
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      this.addForm = addForm;
      this.userId = addForm.userId;
      this.remoteMethod(addForm.userName);
    }
    console.log(this.addForm);
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          dataList: this.addForm.updateList.map((v) => {
            return {
              userIdMain: v.userIdMain,
              userIdDeputy: v.userIdDeputy,
            }
          }),
        };
        this.$q.newProduct
          .cameramanConfigSave({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    remoteMethod(query) {
      console.log(query);
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.addForm.updateList[this.oneIndex].userList = res.data.list;
          this.loading = false;
        }
      });
    },
    remoteMethod1(query) {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.addForm.updateList[this.twoIndex].userList1 = res.data.list;
          this.loading = false;
        }
      });
    },
    addRow(index) {
      this.addForm.updateList.push({ userId: "", userId1: "" });
    },
    delRow(index) {
      this.addForm.updateList.splice(index, 1);
    },
  },
};
</script>

<style lang="stylus" scoped>

 >>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 200px !important;
}

.content {
  max-height: 60vh
  overflow-y: auto
}

.green {
  background: #EFFFFB;
  color: #0BB78E
  border: 1px solid #0BB78E
  font-family: PingFangSC
  padding: 9px 6px
}
.red {
  background: #FEEFEF;
  color: #FF6767;
  border: 1px solid #FF6767;
  font-family: PingFangSC
  padding: 9px 6px
}
</style>
